"use client";

import { useRouter } from "next/navigation";

import { Button } from "@/components/buttons/Button";
import { createStripePortalAction } from "@/data/payment/actions/createStripePortalAction";
import { User } from "@/types/types";
import { logError } from "@/utils/logError";

export function DowngradeButtons({
  closeModal,
  downgradeStripeSubscriptionId,
}: {
  closeModal: () => void;
  downgradeStripeSubscriptionId: NonNullable<User["stripeSubscriptionId"]>;
}) {
  const router = useRouter();

  const handleDowngrade = async () => {
    try {
      const stripePortalUrl = await createStripePortalAction({
        typeOfPortal: "subscriptionUpdateConfirm",
        stripeIdPriceForSubscriptionUpdateConfirm:
          downgradeStripeSubscriptionId,
      });

      // Should never happen
      if (stripePortalUrl === null) {
        return;
      }

      router.push(stripePortalUrl);
    } catch (error) {
      logError(error);
    }
  };

  return (
    <div className="flex w-full justify-between gap-x-4">
      <Button onClick={closeModal} className="w-full">
        Keep subscription
      </Button>

      <Button variant="error" onClick={handleDowngrade} className="w-full">
        Downgrade
      </Button>
    </div>
  );
}
